module.exports = __webpack_public_path__ + "static/hanko-logo-be499142431d899bd22a7f4785023010.svg";